module.exports = __webpack_public_path__ + "img/zimg117.23a44b7f.png";